App.CourierAppsController = Em.Controller.extend
  env: Em.inject.service('environment')
  session: Em.inject.service('session')

  actions:
    gotoApp: ->
      window.location = @get('env.courierAndroidAppUrl')
      false

    gotoAppIos: ->
      window.location = @get('env.courierIOSAppUrl')
      false

    gotoWeb: ->
      window.location = @get('env.orderMachineWebUrl')
      false
